//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"OutputFile",1,0]],[[[],"GetRunMode",{R_:{runMode:''}},0,1],[["runMode"],"SetRunMode",{},1,1],[["nGroups","mechanicalData"],"GetMechanicalData",{},0,0],[["mechanicalData"],"SetMechanicalData",{},1,0],[["nGroups","mechanicalData"],"GetMcdMechanicalData",{},0,1],[["mechanicalData"],"SetMcdMechanicalData",{},1,1],[["startTime","endTime"],"ProcessMcdSimulationData",{},2,1]],[]];
SPLM.Tooling.SIZERExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SIZERExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SIZERExportBuilder.MechanicalData = class{
    constructor(id,name,solution,torqueGraph,speedGraph,frictionTorque,systemEfficiency,loadInertia,additionalInertia){
        this.id=id;this.name=name;this.solution=solution;this.torqueGraph=torqueGraph;this.speedGraph=speedGraph;this.frictionTorque=frictionTorque;this.systemEfficiency=systemEfficiency;this.loadInertia=loadInertia;this.additionalInertia=additionalInertia;}
    get Id(){return this.id}
    set Id(val){this.id = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Solution(){return this.solution}
    set Solution(val){this.solution = val}
    get Torquegraph(){return this.torqueGraph}
    set Torquegraph(val){this.torqueGraph = val}
    get Speedgraph(){return this.speedGraph}
    set Speedgraph(val){this.speedGraph = val}
    get Frictiontorque(){return this.frictionTorque}
    set Frictiontorque(val){this.frictionTorque = val}
    get Systemefficiency(){return this.systemEfficiency}
    set Systemefficiency(val){this.systemEfficiency = val}
    get Loadinertia(){return this.loadInertia}
    set Loadinertia(val){this.loadInertia = val}
    get Additionalinertia(){return this.additionalInertia}
    set Additionalinertia(val){this.additionalInertia = val}
};

SPLM.Tooling.SIZERExportBuilder.MCDMechanicalData = class{
    constructor(id,name,axisControl,referenceDesignator,frictionTorque,systemEfficiency,loadInertia,additionalInertia){
        this.id=id;this.name=name;this.axisControl=axisControl;this.referenceDesignator=referenceDesignator;this.frictionTorque=frictionTorque;this.systemEfficiency=systemEfficiency;this.loadInertia=loadInertia;this.additionalInertia=additionalInertia;}
    get Id(){return this.id}
    set Id(val){this.id = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Axiscontrol(){return this.axisControl}
    set Axiscontrol(val){this.axisControl = val}
    get Referencedesignator(){return this.referenceDesignator}
    set Referencedesignator(val){this.referenceDesignator = val}
    get Frictiontorque(){return this.frictionTorque}
    set Frictiontorque(val){this.frictionTorque = val}
    get Systemefficiency(){return this.systemEfficiency}
    set Systemefficiency(val){this.systemEfficiency = val}
    get Loadinertia(){return this.loadInertia}
    set Loadinertia(val){this.loadInertia = val}
    get Additionalinertia(){return this.additionalInertia}
    set Additionalinertia(val){this.additionalInertia = val}
};

SPLM.Tooling.SIZERExportBuilder.RunMode = Object.freeze({
    "None" : "None", "Motion" : "Motion", "Mcd" : "Mcd"});

export default SPLM;